import moment from "moment";
import fetchServer from "../fetchServer";

export const changeDateFlow1ParseRoutesController = ({
  payload,
  bookingData,
  data,
}) => {
  const flights = bookingData?.flights || [];
  const newDirections = payload?.newDirections || [];
  const directions = data?.route
    ? flights
    : newDirections.map((segment) => ({
        ...segment,
        flight: flights?.find(
          (flight) => flight?.segmentRef === segment?.segmentRef,
        ),
      }));

  directions.sort(
    (a, b) => new Date(a?.departure?.date) - new Date(b?.departure?.date),
  );

  // Group by segment
  const groupedDirections = Object.values(
    directions.reduce((acc, dir) => {
      const seg = dir?.segment || "unknown";
      if (!acc[seg]) acc[seg] = [];
      acc[seg].push(dir);
      return acc;
    }, {}),
  );

  return groupedDirections;
};

export const changeDateFlow1PayloadContructController = ({
  directions,
  bookingData,
  data,
}) => {
  const destinations =
    data?.route && data?.destinations?.length
      ? data?.destinations?.map((destination) => {
          return {
            from: destination?.from,
            to: destination?.to,
            departure: {
              date: moment(destination?.departureDate).format("YYYY-MM-DD"),
            },
          };
        })
      : directions?.map((direction) => {
          return {
            from: direction[0]?.from,
            to: direction[directions?.length - 1]?.to,
            departure: {
              date: direction?.at(0)?.departure?.date,
            },
          };
        });
  return {
    orderId: bookingData?.bookingId,
    destinations,
  };
};

export const changeOrderByReshop = async (payload) => {
  let result = { return: 0, msg: "Something went wrong updating profile!" };
  await fetchServer({
    method: "POST",
    url: "/product/v1/changeBooking/reshopByOrder",
    data: payload,
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = { return: 1, msg: "Successfull", data: res.data?.data };
      } else result["msg"] = res?.data?.error || result["msg"];
    })
    .catch((err) => {
      console.log("Network Error!");
    });
  return result;
};

export function offerTimeGroupId(offer) {
  if (!offer?.directions) return "";

  return offer.directions.map((direction) =>
    direction
      ?.map((segment) => {
        const depDate = segment?.departure?.date?.replace(/\s+/g, "") || "";
        const depTime = segment?.departure?.time?.replace(/\s+/g, "") || "";
        const arrDate = segment?.arrival?.date?.replace(/\s+/g, "") || "";
        const arrTime = segment?.arrival?.time?.replace(/\s+/g, "") || "";

        return `${depDate}-${depTime}-${arrDate}-${arrTime}`;
      })
      .join("-"),
  );
}

export const changeOrderGroupOrdersByTime = (offers, direction) => {
  let updatedOffers = [];
  const standaloneOffers = offers
    ?.filter((offer) => !offer?.isCombinable)
    ?.map((offer) => ({ id: offer?.id, type: "standalone", offer }));
  const combinableOffers = offers?.filter((offer) => offer?.isCombinable);
  updatedOffers = [...standaloneOffers];
  for (const offer of combinableOffers) {
    const offerTimeCats = offerTimeGroupId(offer);
    const groupId = offerTimeCats[direction];
    if (updatedOffers?.find((item) => item?.id === groupId)) {
      updatedOffers = updatedOffers?.map((item) =>
        item.id === groupId
          ? { ...item, offers: [...item?.offers, offer] }
          : item,
      );
      continue;
    }
    updatedOffers.push({
      id: groupId,
      firstOffer: offer,
      offers: [offer],
    });
  }
  return updatedOffers;
};

export function formatTimeAgo(isoString) {
  const now = moment();
  const then = moment(isoString);
  const diffSeconds = now.diff(then, "seconds");

  if (diffSeconds < 60) {
    // Less than a minute → show seconds
    return `${diffSeconds <= 1 ? 1 : diffSeconds} second${
      diffSeconds === 1 ? "" : "s"
    } ago`;
  }

  const diffMinutes = now.diff(then, "minutes");
  if (diffMinutes < 60) {
    // Less than an hour → show minutes
    return `${diffMinutes} minute${diffMinutes === 1 ? "" : "s"} ago`;
  }

  const diffHours = now.diff(then, "hours");
  // 1 hour or more → show hours only
  return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;
}

export const changeOrderRouteChange = (oldOffer, selectedOffer) => {
  if (!selectedOffer) return false;
  const oldDirections = oldOffer?.flights || [];
  const groupedOldDirections = Object.values(
    oldDirections.reduce((acc, flight) => {
      const key = flight.segment;
      if (!acc[key]) acc[key] = [];
      acc[key].push(flight);
      return acc;
    }, {}),
  );

  const newDirections = selectedOffer?.directions || [];

  if (groupedOldDirections?.length !== newDirections?.length) return false;
  const oldDirectionRouteId = groupedOldDirections
    ?.map(
      (direction) =>
        `${direction[0]?.departureLocation}-${
          direction[direction?.length - 1]?.arrivalLocation
        }`,
    )
    .join("-");
  const newDirectionRouteId = newDirections
    ?.map(
      (direction) =>
        `${direction[0]?.departure?.location}-${
          direction[direction?.length - 1]?.arrival?.location
        }`,
    )
    .join("-");
  return oldDirectionRouteId !== newDirectionRouteId;
};

export const changeOrderContructFlightDetails = (order) => {
  const booking = order?.flightObj || order?.flightBooking?.at(0) || {};
  const selectedOffer =
    typeof order?.selectedOffer === "string"
      ? JSON.parse(order?.selectedOffer)
      : order?.selectedOffer || null;
  if (!selectedOffer)
    return {
      flights: booking?.flights || [],
      destinations: booking?.destinations || [],
    };
  const oldFlights = Array.isArray(booking?.flights) ? booking.flights : [];

  const groupedFlights = Object.values(
    oldFlights.reduce((acc, flight) => {
      const segmentKey = String(flight?.segment ?? "unknown");
      if (!acc[segmentKey]) acc[segmentKey] = [];
      acc[segmentKey].push(flight);
      return acc;
    }, {}),
  );
  const routeGroupedFlights = Object.values(groupedFlights)
    .map((flights) => {
      if (!Array.isArray(flights) || flights.length === 0) return null;

      const first = flights[0];
      const last = flights[flights.length - 1];

      return {
        route: `${first?.departureLocation}-${last?.arrivalLocation}`,
        segments: flights,
        segmentIndex: String(first?.segment ?? "unknown"),
      };
    })
    .filter(Boolean)
    .sort((a, b) => {
      const ai = Number(a.segmentIndex);
      const bi = Number(b.segmentIndex);

      // if both are numbers, sort numeric; otherwise keep stable-ish order
      if (!Number.isNaN(ai) && !Number.isNaN(bi)) return ai - bi;

      // fallback string compare
      return String(a.segmentIndex).localeCompare(String(b.segmentIndex));
    });

  const directions = Array.isArray(selectedOffer?.directions)
    ? selectedOffer.directions
    : [];

  const routeGroupedSelectedFlights = directions.reduce((acc, dir) => {
    const flights = Array.isArray(dir?.flights)
      ? dir.flights
      : Array.isArray(dir?.segments)
        ? dir.segments
        : Array.isArray(dir)
          ? dir
          : [];

    if (!flights.length) return acc;

    const first = flights[0];
    const last = flights[flights.length - 1];

    const dep = first?.departure?.location;
    const arr = last?.arrival?.location;

    if (!dep || !arr) return acc;

    const routeKey = `${dep}-${arr}`;
    acc[routeKey] = flights?.map((segment) => ({
      _id: selectedOffer?.id,
      offerId: segment?.segmentRef,
      stops: segment?.numberOfStops,
      aircraftCode: segment?.aircraftCode,
      flightNumber: segment?.flightNumber,
      departureTime: segment?.departure?.time,
      departureDate: segment?.departure?.date,
      departureLocation: segment?.departure?.location,
      departureAirport: segment?.departure?.airport,
      departureLocationName: segment?.departure?.city,
      arrivalTime: segment?.arrival?.time,
      arrivalDate: segment?.arrival?.date,
      arrivalLocation: segment?.arrival?.location,
      arrivalAirport: segment?.arrival?.airport,
      arrivalLocationName: segment?.arrival?.city,
      cabinClass: segment?.cabinClass,
      bookingClass: segment?.bookingClass,
      segmentRef: segment?.segmentRef,
      airlineImage: segment?.airline?.image?.url,
      airlineName: segment?.airline?.image?.description,
      airline: segment?.airline?.marketing,
    }));

    return acc;
  }, {});

  const mergedRouteGroupedFlights = routeGroupedFlights.map((item) => {
    const newSegments = routeGroupedSelectedFlights?.[item.route];

    if (!Array.isArray(newSegments) || newSegments.length === 0) {
      return item;
    }

    return {
      ...item,
      segments: newSegments,
    };
  });

  const flights = [];
  const destinations = [];
  for (const group of mergedRouteGroupedFlights) {
    for (const segment of group.segments) {
      flights.push({ ...segment, segment: group.segmentIndex });
    }
    const firstSegment = group.segments[0];
    const lastSegment = group.segments[group.segments.length - 1];
    destinations.push({
      from: firstSegment?.departureLocation || "",
      to: lastSegment?.arrivalLocation || "",
      departureDate: firstSegment?.departureDate
        ? moment(
            firstSegment.departureDate,
            ["YYYY-MM-DD", "MMM DD YYYY", "MMM D YYYY"],
            true,
          ).isValid()
          ? moment(firstSegment.departureDate).format("YYYY-MM-DD")
          : ""
        : "",
    });
  }
  // console.log({ order, selectedOffer, booking });

  return {
    flights,
    destinations,
  };
};

export const changeOrderConfirmTravellers = (data) => {
  const travellers = data?.passengerInfo?.map(({ _id, ...obj }) => obj);
  const booking = data?.flightObj || data?.flightBooking?.at(0) || {};
  const bookedTravellers = Array.isArray(booking?.travelers)
    ? booking.travelers
    : [];
  const newTravellers = travellers?.map((traveler) => {
    const bookedTraveller = bookedTravellers?.find(
      (item) => item?.id === traveler?.id,
    );
    if (bookedTraveller?.pnrList) traveler.pnrList = bookedTraveller.pnrList;
    if (bookedTraveller?.ticketNumbers)
      traveler.ticketNumbers = bookedTraveller.ticketNumbers;
    return traveler;
  });
  return newTravellers;
};
